const DISABLED_SETTING_VALUE = "N";

type PortalAvailabilitySettings = {
  system_payment_opt?: unknown;
  recurring_payment?: unknown;
};

/**
 * Portal availability is enabled by default. Only an explicit `N` from the
 * portal settings endpoint disables access; missing and blank values therefore
 * retain the requested `Y` default.
 */
export const isPortalAvailable = (
  settings: PortalAvailabilitySettings | null | undefined
): boolean => {
  const settingValues = [
    settings?.system_payment_opt,
    settings?.recurring_payment,
  ];

  return !settingValues.some(
    (value) =>
      typeof value === "string" &&
      value.trim().toUpperCase() === DISABLED_SETTING_VALUE
  );
};
